

import { Power, Trash2 } from "lucide-react";

interface BulkActionsBarProps {
  selectedCount: number;
  onSetActive: () => void;
  onSetInactive: () => void;
  onDelete: () => void;
  onCancel: () => void;
}

export function BulkActionsBar({
  selectedCount,
  onSetActive,
  onSetInactive,
  onDelete,
  onCancel,
}: BulkActionsBarProps) {
  return (
    <div className="mb-4 p-4 bg-amber-50 border border-amber-200 rounded-xl flex items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-amber-800">{selectedCount} vendors selected</span>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <button
          onClick={onSetActive}
          className="flex items-center gap-2 px-3 py-2 rounded-lg bg-emerald-100 text-emerald-700 text-sm font-medium hover:bg-emerald-200 transition-colors"
        >
          <Power className="w-4 h-4" />
          Set Active
        </button>
        <button
          onClick={onSetInactive}
          className="flex items-center gap-2 px-3 py-2 rounded-lg bg-stone-100 text-stone-700 text-sm font-medium hover:bg-stone-200 transition-colors"
        >
          <Power className="w-4 h-4" />
          Set Inactive
        </button>
        <button
          onClick={onDelete}
          className="flex items-center gap-2 px-3 py-2 rounded-lg bg-rose-100 text-rose-700 text-sm font-medium hover:bg-rose-200 transition-colors"
        >
          <Trash2 className="w-4 h-4" />
          Delete
        </button>
        <button
          onClick={onCancel}
          className="px-3 py-2 rounded-lg bg-white text-stone-600 text-sm font-medium hover:bg-stone-100 transition-colors border border-stone-300"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
